// extracted by mini-css-extract-plugin
module.exports = {"hero-img":"HeroSection_hero-img__2dVgK","section":"HeroSection_section__3otYS"};